<spinner *ngIf="generalLoader" [spinner]="spinner"></spinner>
<div [ngStyle]="(generalLoader && (!spinner || !spinner.isDim )) ? {'display': 'none'}: {'display': 'block'}">
    <router-outlet></router-outlet>
</div>
